import React from "react";
import footerBg from "../../assets/images/backgrounds/footerBg.webp";
import { ROUTES_NAME } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import Button from "../../components/button/Button";
import Bach from "../../components/bach/Bach";
import defaultS from "../../assets/images/simulations/default.webp";
import iit from "../../assets/images/simulations/iit.webp";
import cat from "../../assets/images/simulations/cat.webp";
import railway from "../../assets/images/simulations/railway.webp";

const examList = [
  {
      id:1,
    name: "Default",
    image: defaultS,
  },
  {
      id:2,
    name: "IIT",
    image: iit,
  },
  {
      id:3,
    name: "CAT",
    image: cat,
  },
  {
      id:4,
    name: "SSC/ Railways/ Gate ",
    image: railway,
  },
];

export default function RealExamSimulations() {
  const navigate = useNavigate();
  
  const createSlug = (name) => {
    return name
      .toLowerCase()             // make all lowercase
      .replace(/[\/\s]+/g, '-')  // replace / and spaces with -
      // .replace(/[^a-z0-9\-]/g, '') // remove other special characters (optional)
      // .replace(/\-+/g, '-')      // remove duplicate hyphens
      // .replace(/^-+|-+$/g, '');  // trim hyphens from start/end
  };

  const handleClick = (exam) => {
    const slug = createSlug(exam.name);
    const url = `${ROUTES_NAME.SIMULATION.replace(":name", slug)}?id=${exam.id}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  

  return (
    <section
      className="md:py-16 py-8 px-4 text-center bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      {/* Tag */}
      <Bach>Practice Like It's the Final Exam</Bach>

      {/* Heading */}
      <h2 className="text-2xl md:text-3xl mb-4">Real Exam Simulations</h2>

      {/* Decorative Line */}
      <div className="flex justify-center items-center gap-2 mb-10">
        <span className="w-24 h-[2px] bg-black/40"></span>
        <span className="w-4 h-[2px] bg-black/40"></span>
        <span className="w-24 h-[2px] bg-black/40"></span>
      </div>

      {/* Grid of Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {examList.map((exam, index) => (
          <div
           onClick={()=>handleClick(exam)}
            key={index}
            className="rounded-lg items-end justify-center transition-all duration-300 hover:shadow-xl shadow-lg"
          >
            <img
              src={exam.image}
              alt={exam.name}
              className="rounded-lg w-full cursor-pointer"
              loading="lazy"
              decoding="async"
            />
            <p
              style={{
                backgroundImage:
                  "linear-gradient(to bottom, rgba(255,255,255,1) 10%, rgba(255, 150, 36,0.5) 100%)",
              }}
              className="text-base font-medium rounded-lg cursor-pointer"
            >
              {exam.name}
            </p>
          </div>
        ))}
      </div>

      {/* Button */}
      <div className="mt-10">
        <Button onClick={() => navigate(ROUTES_NAME.BOOK_A_DEMO)}>
          Book A Demo
        </Button>
      </div>
    </section>
  );
}
